import { GetCreditorAccountSummaryRequest } from '../types/GetCreditorAccountSummaryRequest';
import RestApiClient from '../../../../core/api/RestApiClient';
import { CreditorAccountSummaryType } from '../types/CreditorAccountSummaryType';

export default {
  getCreditorAccountSummary: async (request: GetCreditorAccountSummaryRequest): Promise<CreditorAccountSummaryType> => {
    return await RestApiClient.post('modules/CreditorAccountSummaryModule/creditorAccountSummary', request);
  },
};
